import { render } from "./DashboardUsers.vue?vue&type=template&id=66ee8d15&scoped=true"
import script from "./DashboardUsers.vue?vue&type=script&lang=js"
export * from "./DashboardUsers.vue?vue&type=script&lang=js"

import "./DashboardUsers.vue?vue&type=style&index=0&id=66ee8d15&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ee8d15"]])

export default __exports__